import { Modal } from "common/Modal"
import { Table } from "common/Table/Table"
import { useNotifications } from "hooks/useNotification"
import { useRouter } from "hooks/useRouter"
import { useCallback, useEffect, useState } from "react"
import { formatPhone } from "./Contacts"
import { Loader } from "common/Loader"
import swal from "sweetalert"
import UserService from "services/user.service"
import CopyText from "common/CopyText"

const service = new UserService()

export const CompanyDetails = () => {
  const { push, params } = useRouter()
  const companyId = params.id ?? ""
  const badgeId = params.badge ?? ""

  const columns = [
    { key: "fullname", dbColName: "fullname", title: "fullname" },
    { key: "companyId", dbColName: "companyId", title: "companyId" },
    {
      key: "phone_number",
      dbColName: "phone_number",
      title: "phone_number",
      render: (phone) => (
        <CopyText text={formatPhone(phone)} copyText={phone} />
      ),
    },
    { key: "companyType", dbColName: "companyType", title: "companyType" },
    { key: "email", dbColName: "email", title: "email" },
    { key: "roles", dbColName: "roles", title: "roles" },
    { key: "badgeId", dbColName: "badgeId", title: "badgeId" },
    { key: "position", dbColName: "position", title: "position" },
    { key: "leader_name", dbColName: "leader_name", title: "Reported to" },
    {
      key: "profile_picture",
      dbColName: "profile_picture",
      title: "profile_picture",
    },
    {
      key: "verification_code",
      dbColName: "verification_code",
      title: "verification_code",
    },
    {
      key: "enable_notifications",
      dbColName: "enable_notifications",
      title: "enable_notifications",
    },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <div className="flex gap-2">
            <button
              type="button"
              className="pl-3 text-right text-red-500"
              onClick={() => handleDelete(row.badgeId)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => {
                setState({
                  ...state,
                  first_name: row.first_name,
                  last_name: row.last_name,
                  email: row.email,
                  phone: row.phone_number,
                  position: row.position,
                })
                setIsEditing(true)
                setShowModal(true)
                setSelectedId(row.badgeId)
              }}
              className="text-blue-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </button>
          </div>
        )
      },
    },
  ]

  const officeColumns = [
    {
      key: "id",
      dbColName: "_id",
      title: "Office Id",
      render: (text) => <CopyText text={text} copyText={text} />,
    },
    {
      key: "companyId",
      dbColName: "companyId",
      title: "company Id",
      render: (text) => <CopyText text={text} copyText={text} />,
    },
    { key: "name", dbColName: "name", title: "Name" },
    { key: "address", dbColName: "address", title: "Address" },
    { key: "city", dbColName: "city", title: "City" },
    { key: "state", dbColName: "state", title: "State" },
    { key: "zip", dbColName: "zip", title: "Zip" },
    { key: "country", dbColName: "country", title: "Country" },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <button
            type="button"
            onClick={() => handleDeleteLocation(row._id)}
            className="pl-3 text-right text-red-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
          </button>
        )
      },
    },
  ]

  const [users, setUsers] = useState([])
  const [loadingData, setLoadingData] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [showLocationModal, setShowLocationModal] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [selectedId, setSelectedId] = useState("")
  const [locationState, setLocationState] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  })
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    email: "",
    leader_id: "",
    leader_name: "",
    position: "",
    phone: "",
    companyId,
    role: "",
  })
  const [officeLocations, setOfficeLocations] = useState([])
  const [companyData, setCompanyData] = useState<any>({
    _id: "",
    title: "",
    companyId: "",
    website: "",
    office_locations: [],
    products: [],
    hierarchy: [],
    parsedHierarchy: [],
    social_media: {},
  })
  const { errorMessage, successMessage } = useNotifications()
  const [hierarchyModal, setHierarchyModal] = useState(false)

  const fetchUsers = useCallback(() => {
    service
      .companyUsers(companyId, badgeId)
      .then((resp) => {
        setUsers(resp.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const fetchCompanyDetails = useCallback(() => {
    setLoadingData(true)
    service
      .companyDetails(companyId)
      .then((resp) => {
        setCompanyData({
          ...resp.data.data,
          hierarchy: resp.data.data.hierarchy.map((item) => {
            const [value, label] = item.split(":")
            return {
              label: item,
              value: item,
              newValue: label,
            }
          }),
        })
        setLoadingData(false)
      })
      .catch((err) => {
        console.log(err)
        setLoadingData(false)
      })
  }, [])

  const fetchOfficeLocations = useCallback(() => {
    service
      .myOffices(companyId)
      .then((resp) => {
        setOfficeLocations(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  const resetState = () => {
    setState({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      leader_id: "",
      leader_name: "",
      position: "",
      companyId,
      role: "",
    })
  }

  useEffect(() => {
    fetchCompanyDetails()
    fetchUsers()
    fetchOfficeLocations()
  }, [params])

  const handleSubmit = (e: any) => {
    e.preventDefault()
    // setLoadingData(true);

    setSubmitting(true)
    const payload: any = { ...state }

    if (!isEditing) {
      delete payload.position

      service
        .addCompanyUser(payload)
        .then((resp) => {
          setShowModal(false)
          fetchUsers()
          resetState()
          successMessage("User added successfully")
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          setSubmitting(false)
        })
    } else {
      delete payload.role

      service
        .updateCompanyUser(selectedId, payload)
        .then((resp) => {
          setShowModal(false)
          fetchUsers()
          setIsEditing(false)
          resetState()
          successMessage("User updated successfully")
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  }

  const handleAddLocation = (e) => {
    e.preventDefault()

    if (!locationState.name) {
      errorMessage("Please enter office name")
      return
    }

    service
      .addCompanyLocation(badgeId, locationState)
      .then(() => {
        setShowLocationModal(false)
        fetchOfficeLocations()
        setLocationState({
          name: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        })
        successMessage("Location added successfully")
      })
      .catch((err) => {
        console.log(err)
        setLoadingData(false)
      })
  }

  const handleDelete = (id: string) => {
    swal({
      title: "Are you sure, you want to delete this user?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteCompanyUser(id)
          .then((resp) => {
            successMessage("User deleted successfully")
            fetchUsers()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  const handleChangeLocation = (e: any) => {
    const { name, value } = e.target
    setLocationState((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleDeleteLocation = (id: string) => {
    swal({
      title: "Are you sure, you want to delete this location?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteOffice(id)
          .then(() => {
            successMessage("Location deleted successfully")
            fetchOfficeLocations()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  const handleChange = (event, index) => {
    const newValue = event.target.value
    const shallowCopy = { ...companyData }

    shallowCopy.hierarchy[index] = {
      ...shallowCopy.hierarchy[index],
      newValue,
    }
    setCompanyData(shallowCopy)
  }

  const handleSave = async () => {
    const modifiedHierarchy = companyData.hierarchy.map((item) => {
      const [part1, part2] = item.value.split(":")
      if (item.newValue) {
        return `${part1}:${item.newValue}`
      }
      return item.value
    })

    const payload = {
      ...companyData,
      hierarchy: modifiedHierarchy,
    }

    delete payload._id

    try {
      await service.updateCompanyDetails(companyId, payload)
      fetchCompanyDetails()
      successMessage("Hierarchy updated successfully")
      setHierarchyModal(false)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeUser = (e) => {
    const id = e.target.value
    const selectedOption = e.target.selectedOptions[0]
    const fullname = selectedOption.getAttribute("data-name")

    setState({
      ...state,
      leader_id: id,
      leader_name: fullname,
    })
  }

  if (loadingData) {
    return <Loader />
  }

  return (
    <div className="">
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => push("/dealership")}
            className="p-2 bg-white border rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              />
            </svg>
          </button>
          <div>
            <h1 className="page-title">
              Company Details
            </h1>
            <p className="page-subtitle">View details</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="btn-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>

            <span>Add User</span>
          </button>
          <button
            type="button"
            onClick={() => setShowLocationModal(true)}
            className="btn-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>

            <span>Add Office Location</span>
          </button>
          {/* <button
                type="button"
                className="btn-dark">
          <span>View Office Locations</span>
        </button> */}
        </div>
      </div>
      <div className="flex flex-col items-start gap-4 md:flex-row">
        <div className="w-1/4 p-6 bg-white rounded-lg shadow-lg">
            <div className="mb-6 ">
              <h1 className="text-2xl font-bold text-center text-gray-800">
                {companyData?.title}
              </h1>
              <p className="text-sm text-center text-gray-500">
                ID: {companyData?._id}
              </p>
            </div>

            <div className="flex flex-col gap-2">
              {/* Left Column */}
              <div className="">
                <h2 className="mb-2 text-lg font-semibold text-gray-700">
                  Company Info
                </h2>
                <div className="rounded ">
                  <div className="mb-2">
                    <span className="font-medium">Company ID: </span>
                    <span>{companyData?.companyId}</span>
                  </div>
                  <div className="mb-2">
                    <span className="font-medium">Website: </span>
                    <span>{companyData?.website}</span>
                  </div>
                </div>
              </div>

              <div className="">
                <h2 className="mb-2 text-lg font-semibold text-gray-700">
                  Products
                </h2>
                <div className="rounded">
                  <ul className="pl-5 list-disc">
                    {companyData?.products.map((product, index) => (
                      <li key={index} className="mb-2">
                        {product}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Column */}
              <div className="">
                <div className="flex items-center justify-between mb-2">
                  <h2 className="text-lg font-semibold text-gray-700">
                    Company Hierarchy
                  </h2>
                  <button
                    onClick={() => setHierarchyModal(true)}
                    type="button"
                    className="text-blue-600"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                      />
                    </svg>
                  </button>
                </div>
                <div className="rounded ">
                  <ul className="pl-5 list-disc">
                    {companyData?.hierarchy.map((role, index) => (
                      <li key={index} className="mb-2">
                        {role.label}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="">
                <h2 className="mb-2 text-lg font-semibold text-gray-700">
                  Social Media
                </h2>
                <div className="rounded">
                  <ul className="space-y-2">
                    {companyData?.social_media &&
                      Object.entries(companyData?.social_media).map(
                        ([key, value]: any, index) => (
                          <li key={index} className="mb-2">
                            <span className="font-medium">{key}: </span>
                            <span>{value}</span>
                          </li>
                        )
                      )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        <div className="w-full md:w-3/4">
          <Table
            data={users || []}
            setData={setUsers}
            loadingData={false}
            totalItems={users?.length}
            columns={columns}
          />
          <div className="py-6">
            <p className="mb-2 text-xl font-semibold text-gray-700">
              Office Locations
            </p>
            <Table
              data={officeLocations}
              setData={setOfficeLocations}
              loadingData={false}
              totalItems={officeLocations.length}
              columns={officeColumns}
            />
          </div>
        </div>
      </div>

      <Modal
        width="w-full md:w-1/3"
        showModal={showModal}
        setIsEditing={setIsEditing}
        onClick={() => {
          setIsEditing(false)
          setState((prev) => ({
            ...prev,
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            role: "",
          }))
        }}
        setShowModal={setShowModal}
        title={isEditing ? "Update User" : "Add User"}
      >
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="text"
            placeholder="First Name"
            value={state.first_name}
            onChange={(e) => setState({ ...state, first_name: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="text"
            placeholder="Last Name"
            value={state.last_name}
            onChange={(e) => setState({ ...state, last_name: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="email"
            placeholder="Email"
            value={state.email}
            onChange={(e) => setState({ ...state, email: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />
          <input
            type="text"
            value={state.phone}
            placeholder="Phone"
            onChange={(e) => setState({ ...state, phone: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          />

          {/* {isEditing ? (
            <select
              value={state.position}
              defaultValue={state.position}
              onChange={(e) => setState({ ...state, position: e.target.value })}
              className="w-full px-3 py-2 text-sm"
            >
              <option value="">Select Position</option>
              {POSITIONS.map((position: string, index: number) => (
                <option key={index} value={position}>
                  {position}
                </option>
              ))}
            </select>
          ) : ( */}
          <select
            value={state.role}
            onChange={(e) => setState({ ...state, role: e.target.value })}
            className="w-full px-3 py-2 text-sm"
          >
            <option value="">Select Role</option>
            <option value="Owner">Owner</option>
            {companyData.parsedHierarchy.map((role: any, index: number) => (
              <option key={index} value={role}>
                {role}
              </option>
            ))}
          </select>

          <select
            value={state.leader_id}
            onChange={handleChangeUser}
            className="w-full px-3 py-2 text-sm"
          >
            <option value="">Reported to</option>
            {users.map((user: any, index: number) => (
              <option
                key={index}
                value={user.badgeId}
                data-name={user.fullname}
              >
                {user.fullname}
              </option>
            ))}
          </select>
          <button
            type="submit"
            disabled={submitting}
            className="bg-ink hover:bg-gray-800 disabled:cursor-not-allowed rounded-lg font-medium text-sm disabled:bg-opacity-20 text-white p-2.5"
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </form>
      </Modal>

      <Modal
        width="w-full md:w-1/3"
        showModal={showLocationModal}
        setShowModal={setShowLocationModal}
        title="Add Location"
      >
        <form onSubmit={handleAddLocation} className="flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Office Name"
              value={locationState.name}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />
            <input
              type="text"
              name="address"
              placeholder="Address"
              value={locationState.address}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />
            <input
              type="text"
              name="city"
              placeholder="City"
              value={locationState.city}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />
            <input
              type="text"
              name="state"
              placeholder="State"
              value={locationState.state}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />

            <input
              type="text"
              name="zip"
              placeholder="Zip"
              value={locationState.zip}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />
            <input
              type="text"
              name="country"
              placeholder="Country"
              value={locationState.country}
              onChange={(e) => handleChangeLocation(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div>

          <button
            type="submit"
            className="bg-ink hover:bg-gray-800 disabled:cursor-not-allowed rounded-lg font-medium text-sm disabled:bg-green-300 text-white p-2.5"
          >
            Save
          </button>
        </form>
      </Modal>

      <Modal
        title="Update Hierarchy"
        width="w-full md:w-1/3"
        showModal={hierarchyModal}
        setShowModal={setHierarchyModal}
      >
        <div className="flex flex-col gap-1.5">
          {companyData.hierarchy.length > 0 &&
            companyData.hierarchy.map((item, index) => {
              const [value, label] = item?.value?.split(":")

              return (
                <div
                  key={index}
                  className="flex overflow-hidden border border-gray-300 rounded-md focus:ring-0 focus:border-gray-400"
                >
                  <p className="text-sm whitespace-nowrap pt-2.5 px-3 bg-gray-100 top-0.5  rounded-l-md  overflow-hidden">
                    {value}
                  </p>
                  <input
                    type="text"
                    placeholder="Modify value"
                    onChange={(event) => handleChange(event, index)}
                    value={item.newValue}
                    disabled={item.__isNew__}
                    className="border-none disabled:cursor-not-allowed  disabled:bg-gray-100 focus:ring-0 overflow-hidden focus:border-none flex-1 focus:outline-none  px-3 py-2.5 text-sm text-gray-800"
                  />
                </div>
              )
            })}
        </div>
        <button
          type="button"
          onClick={handleSave}
          className="mt-2 w-full bg-ink hover:bg-gray-800 disabled:cursor-not-allowed rounded-lg font-medium text-sm disabled:bg-green-300 text-white p-2.5"
        >
          Save
        </button>
      </Modal>
    </div>
  )
}
